


























import mixins from 'vue-typed-mixins';
import ProviderUtils, {
  ServiceProvider,
  stateSummary,
} from '../../utils/ProviderUtils';
import cloneDeep from 'lodash.clonedeep';
export default mixins().extend({
  props: {
    provider: {
      type: Object as () => ServiceProvider,
    },
  },

  data(): {
    visible: boolean;
    state: string;
    summary?: stateSummary;
  } {
    return {
      visible: false,
      state: 'inactive',
      summary: undefined,
    };
  },

  async mounted() {
    try {
      if (this.provider.state === 'inactive') {
        this.state = 'active';
      } else {
        this.state = 'inactive';
      }
      if (this.provider.id) {
        const resp = await Promise.all([
          ProviderUtils.api.instance.changeState({
            id: this.provider.id,
            persist: false,
            state: this.state,
          }),
        ]);
        this.summary = resp[0];
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
    this.$loading(false);
  },

  methods: {
    handleClick() {
      this.visible = true;
    },

    async submit() {
      try {
        if (this.provider) {
          const provider = cloneDeep(this.provider);
          if (provider.state === 'inactive') {
            this.state = 'active';
          } else {
            this.state = 'inactive';
          }
          if (this.provider.id) {
            await ProviderUtils.api.instance.changeState({
              id: this.provider.id,
              persist: true,
              state: this.state,
            });
          }
          this.$emit('update', {
            state: this.state,
          });
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('page.serviceProvider.changeState.success'),
          });

          this.exit();
        }
      } catch (error) {
        this.$alert.show('set', {
          type: 'error',
          messages: this.$handleAPIError(error, this.$refs.observer),
        });
      }
    },

    exit() {
      this.visible = false;
    },
  },
});
